export enum DienststellenArtEnum {
    AA = 'AA',
    GE = 'GE',
    ZKT = 'ZKT',
    FAMKA = 'FAMKA',
    ZAV = 'ZAV',
}
